export default __webpack_public_path__ + "static/media/down-arrow.b96f8661.svg";